import React from 'react';
import {
  Box, Typography, IconButton, Stack, Grid
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';

import { SvgIcon } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import PinterestIcon from '@mui/icons-material/Pinterest';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';


const XIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M21.5 2h-4.59L12 9.08 7.09 2H2l7.95 11.38L2.5 22h4.6L12 14.91 16.91 22h4.59l-7.88-11.13L21.5 2z" />
  </SvgIcon>
);
const socialIcons = [
  { icon: FacebookIcon, link: 'https://facebook.com' },
    { icon: XIcon, link: 'https://x.com/luluatalomran' },
  { icon: InstagramIcon, link: 'https://www.instagram.com/luluatalomran/' },
  { icon: PinterestIcon, link: 'https://pinterest.com' },
];

const MotionIcon = motion(IconButton);

export default function Footer() {
  const { t, i18n } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 12,
        py: 6,
        px: { xs: 2, sm: 6, md: 12 },
        bgcolor: '#0f172a',
        color: 'white',
        borderTopLeftRadius: 40,
        borderTopRightRadius: 40,
        boxShadow: '0 -10px 30px rgba(0,0,0,0.3)',
        direction: i18n.dir(), // RTL/LTR support
        textAlign: i18n.dir() === 'rtl' ? 'right' : 'left',
      }}
    >
      <Grid container spacing={4} alignItems="center" justifyContent="space-between">
        {/* Vision 2030 Logo */}
        <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'center', md: i18n.dir() === 'rtl' ? 'right' : 'left' }, order: { xs: 1, md: 1 } }}>
          <Box
            component="img"
            src="/image/Vision.png"
            alt={t('visionAlt')}
            sx={{
              height: 70,
              objectFit: 'contain',
              filter: 'drop-shadow(0 2px 6px rgba(255,255,255,0.1))',
            }}
          />
        </Grid>

        {/* Center: Social Media Icons */}
        <Grid item xs={12} md={4} sx={{ order: { xs: 2, md: 2 } }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              {t('followUs')}
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center">
              {socialIcons.map(({ icon: Icon, link }, i) => (
                <MotionIcon
                  key={i}
                  component="a"
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{
                    scale: 1.4,
                    rotate: 10,
                    boxShadow: '0 8px 20px rgba(25, 118, 210, 0.5)',
                    transition: { type: 'spring', stiffness: 300 }
                  }}
                  sx={{
                    backgroundColor: '#1e293b',
                    color: '#90caf9',
                    borderRadius: '50%',
                    p: 1.5,
                    fontSize: 28,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                    '&:hover': {
                      backgroundColor: '#1976d2',
                      color: 'white'
                    }
                  }}
                  aria-label={t('followUs')}
                >
                  <Icon fontSize="inherit" />
                </MotionIcon>
              ))}
            </Stack>
          </Box>
        </Grid>

        {/* Bottom: Company Info */}
        <Grid item xs={12} sx={{ order: { xs: 3, md: 3 }, textAlign: 'center', mt: { xs: 4, md: 0 } }}>
          <Typography variant="body2" sx={{ color: '#aaa', fontSize: 14, whiteSpace: 'pre-line' }}>
            {t('copyright', { year })}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
